export default __webpack_public_path__ + "static/media/icon-boleto.288b96b8.svg";